import styles from './styles.module.scss';

export const ModalFooter = ({ amount, color }) => (
  <div className={styles.modalFooter} style={{ backgroundColor: `${color}14` }}>
    <p className={styles.amountText}>
      Total Amount:{' '}
      <span className={styles.amount} style={{ color: color }}>
        {amount}
      </span>
    </p>
  </div>
);
